import React, { useState } from 'react';
import { Button } from './Button';
import { Flame, Star, CheckCircle2, Circle, ShieldCheck, Zap, Download } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function Pricing() {
  const [selectedPlan, setSelectedPlan] = useState<'megapack' | 'elite'>('elite');
  const handleCheckout = () => {
    const url = selectedPlan === 'megapack' ? 'https://checkout.academiaonlinepro.shop/cart/47110701416633:1' : 'https://checkout.academiaonlinepro.shop/cart/47110791135417:1';
    window.open(url, '_blank');
  };
  return <section className="py-20 px-4 bg-[#0A1628] relative" id="precio-lanzamiento" data-id="element-258">
      <div className="max-w-3xl mx-auto" data-id="element-259">
        <CountdownTimer data-id="element-260" />

        <div className="text-center mb-10" data-id="element-261">
          <h2 className="text-4xl md:text-5xl font-anton text-white mb-4" data-id="element-262">
            Elegí tu Megapack Resuelto:
          </h2>
          <p className="text-gray-400" data-id="element-263">
            Seleccioná la opción que mejor se adapte a tus objetivos
          </p>
        </div>

        <div className="space-y-4 mb-8" data-id="element-264">
          {/* Option 1: Megapack */}
          <div onClick={() => setSelectedPlan('megapack')} className={`cursor-pointer rounded-2xl p-5 border-2 transition-all flex flex-col sm:flex-row sm:items-center gap-4 ${selectedPlan === 'megapack' ? 'bg-[#0F1F3D] border-[#C6F432] shadow-[0_0_20px_rgba(198,244,50,0.15)]' : 'bg-[#0A1628] border-white/10 hover:border-white/30'}`} data-id="element-265">
            <div className="flex items-center gap-4 w-full sm:w-auto flex-1" data-id="element-266">
              <div className="shrink-0" data-id="element-267">
                {selectedPlan === 'megapack' ? <CheckCircle2 className="text-[#C6F432] fill-[#C6F432]/20" size={28} data-id="element-268" /> : <Circle className="text-gray-500" size={28} data-id="element-269" />}
              </div>
              <div className="flex-1" data-id="element-270">
                <h3 className="text-white font-bold text-lg" data-id="element-271">
                  📘 MEGAPACK PADEL RESUELTO
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-272">6 Módulos + 6 Bonos</p>
              </div>
            </div>
            <div className="text-left sm:text-right pl-12 sm:pl-0" data-id="element-273">
              <p className="text-gray-500 line-through text-sm font-bold" data-id="element-274">
                $59.990
              </p>
              <p className="text-2xl font-anton text-white" data-id="element-275">$24.990</p>
            </div>
          </div>

          {/* Option 2: Elite */}
          <div onClick={() => setSelectedPlan('elite')} className={`cursor-pointer rounded-2xl p-5 border-2 transition-all flex flex-col sm:flex-row sm:items-center gap-4 relative ${selectedPlan === 'elite' ? 'bg-gradient-to-r from-[#0F1F3D] to-[#1a2f52] border-[#C6F432] shadow-[0_0_30px_rgba(198,244,50,0.2)]' : 'bg-[#0A1628] border-white/10 hover:border-white/30'}`} data-id="element-276">
            <div className="absolute -top-3 left-6 bg-[#C6F432] text-[#0A1628] text-[10px] md:text-xs font-black px-3 py-1 rounded-full flex items-center gap-1 shadow-md uppercase tracking-wider" data-id="element-277">
              <Star size={12} className="fill-[#0A1628]" data-id="element-278" /> MÁS ELEGIDO
            </div>

            <div className="flex items-start sm:items-center gap-4 w-full sm:w-auto flex-1 mt-2 sm:mt-0" data-id="element-279">
              <div className="shrink-0 mt-1 sm:mt-0" data-id="element-280">
                {selectedPlan === 'elite' ? <CheckCircle2 className="text-[#C6F432] fill-[#C6F432]/20" size={28} data-id="element-281" /> : <Circle className="text-gray-500" size={28} data-id="element-282" />}
              </div>
              <div className="flex-1" data-id="element-283">
                <h3 className="text-[#C6F432] font-bold text-lg flex items-center gap-2" data-id="element-284">
                  🏆 PROFE ÉLITE PADEL™
                </h3>
                <p className="text-gray-300 text-sm font-medium" data-id="element-285">
                  SISTEMA DE NEGOCIO Y ESCALADO
                </p>
                <p className="text-gray-400 text-xs mt-1" data-id="element-286">
                  6 Módulos + 6 Bonos + Sistema de Alumnos + Programa 90 Días
                </p>
              </div>
            </div>
            <div className="text-left sm:text-right pl-12 sm:pl-0" data-id="element-287">
              <p className="text-gray-500 line-through text-sm font-bold" data-id="element-288">
                $79.990
              </p>
              <p className="text-3xl font-anton text-[#C6F432]" data-id="element-289">$29.990</p>
            </div>
          </div>
        </div>

        <Button onClick={handleCheckout} className="w-full text-lg md:text-xl py-5 animate-pulse shadow-[0_0_30px_rgba(198,244,50,0.3)]" data-id="element-290">
          👉 QUIERO MI MEGAPACK PADEL RESUELTO
        </Button>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-6 text-xs text-gray-400" data-id="element-291">
          <span className="flex items-center gap-1.5" data-id="element-292">
            <ShieldCheck size={16} className="text-[#C6F432]" data-id="element-293" /> Pago Seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-294">
            <Zap size={16} className="text-[#C6F432]" data-id="element-295" /> Acceso Inmediato
          </span>
          <span className="flex items-center gap-1.5" data-id="element-296">
            <Download size={16} className="text-[#C6F432]" data-id="element-297" /> PDF Digital
          </span>
        </div>

        {/* Elite Features Breakdown */}
        <div className="mt-12 bg-[#0F1F3D] border border-white/5 rounded-2xl p-6 md:p-8" data-id="element-298">
          <h4 className="text-center text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-299">
            ¿Qué agrega el PACK ÉLITE™?
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6" data-id="element-300">
            <div className="flex flex-col items-center text-center gap-2" data-id="element-301">
              <div className="bg-orange-500/10 p-3 rounded-full" data-id="element-302">
                <Flame className="text-orange-500" size={24} data-id="element-303" />
              </div>
              <span className="text-sm text-gray-300 font-medium" data-id="element-304">
                Entrenamiento avanzado
              </span>
            </div>
            <div className="flex flex-col items-center text-center gap-2" data-id="element-305">
              <div className="bg-orange-500/10 p-3 rounded-full" data-id="element-306">
                <Flame className="text-orange-500" size={24} data-id="element-307" />
              </div>
              <span className="text-sm text-gray-300 font-medium" data-id="element-308">
                Clases tácticas
              </span>
            </div>
            <div className="flex flex-col items-center text-center gap-2" data-id="element-309">
              <div className="bg-orange-500/10 p-3 rounded-full" data-id="element-310">
                <Flame className="text-orange-500" size={24} data-id="element-311" />
              </div>
              <span className="text-sm text-gray-300 font-medium" data-id="element-312">
                Programa listo para vender
              </span>
            </div>
          </div>
          <div className="mt-8 text-center border-t border-white/5 pt-6" data-id="element-313">
            <span className="inline-flex items-center gap-2 text-[#C6F432] font-bold text-sm bg-[#C6F432]/10 px-5 py-2.5 rounded-full border border-[#C6F432]/20" data-id="element-314">
              💰 AUMENTÁS TUS INGRESOS
            </span>
          </div>
        </div>
      </div>
    </section>;
}